import { toaster } from '@!/components/ui/toaster'

export const useNavigationHandler = () => {
  const redirectToLoginWithToast = () => {
    toaster.create({
      title: 'Info',
      description: '作品を購入するにはログインが必要です。',
      type: 'info',
      duration: 2000,
      closable: true,
      onStatusChange: ({ status }) => {
        if (status === 'unmounted') {
          window.location.href = '/user/login'
        }
      },
    })
  }

  return { redirectToLoginWithToast }
}
